import styled from 'styled-components';

export const IFrameContainer = styled.div`
  padding: 2rem;
`;
